import { connect } from 'react-redux';
import Home from '../views/Home';

const mapStateToProps = state => {
  return { user: state.data.user };
};

export default connect(mapStateToProps, null)(Home);
